import { Usedata } from "./Context/Allcontext"
import Moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import { useRef } from "react";
import { UseAuth } from "./AuthContext/AuthContext";
function Jawaab(){
    const Tirsi_Id =  Math.round(Math.random(154587) * 4554787) 
    console.log(Tirsi_Id)
    const {crentuser} = UseAuth()
    const name = crentuser && String(crentuser.email).substring(0, 10)

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    }, Tirsi_Id +1); 
    const formatDate = Moment().format('DD-MM-YYYY')
    const {
        ActiveJawaab ,
        ActiveSako,
        Nooc,
        NDahab,
        N_Midho,
        Xadiga, 
        Shardi1,
        Shardi2,
        Shardi3,
        jawaab,
        muti
    } = Usedata()
    return(
        <div className="jawaab_sako active">
        <section className="rashiid_gudoomiye active" ref={componentRef}>
        <div className="haye">
            <div className="rasiid_model">
                {/* <!-----rasiidka daabacaada -----------> */}
                <div className="rasiid">
                    <div className="logo_and_head_id">
                        <div className="logo">
                            <img src="/images/Rasiid_logo.png" />
                            <h2 className="Logo_name">Shabakada E-Sako</h2>
                        </div>
                        <div className="id">
                            <p className="qoraal">Rasiidka Jawaabta</p>
                            <ul>
                                <li>
                                    ID : {Tirsi_Id}
                                </li>
                                <li>
                                    Taariikh : {formatDate}
                                </li>
                                <li>
                                    Akoonka : {name ? name : "Bila Akoon"}
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                    <div className="content table">
                        <table className="table">
                            <tr>
                                <th>#</th>
                                <th>Xadiga </th>
                                <th>Nooca</th>
                                <th>Jawaabta</th>
                            </tr>
                            <tr>
                                <td>01</td>
                                {Nooc === "Lacag" ? 
                                <td>{Xadiga} $</td>
                                :Nooc === "Dahab" || Nooc === "Fido"  || Nooc === "Rikaas"?
                                <td>{Xadiga} Giraam</td>
                                : Nooc === "Midho"?
                                <td>{Xadiga} Kg</td>
                                :<td>{Xadiga} Neef</td>
                                }
                                {Nooc === "Dahab" ?
                                <td>{Nooc} | {NDahab}</td>
                                : Nooc === "Midho" ?
                                <td>{Nooc} | {N_Midho}</td>
                                :<td>{Nooc}</td>
                                }
                                
                                {Nooc === "Lacag" ? 
                                <td>{jawaab} $</td>
                                :Nooc === "Dahab" || Nooc === "Fido" || Nooc === "Rikaas" ?
                                <td>{jawaab} Giraam</td>
                                : Nooc === "Midho"?
                                <td>{jawaab} Kg</td>
                                :<td>{jawaab} Neef</td>
                                }
                            </tr>
                            </table>
                    </div>
                    <div className="saxiisa_gudoomiye_and_terms">
                        <div className="xeerar">
                            <h2>Shuruudaha</h2>
                            <p className="shardi_rasiid">
                                {Shardi1}
                            </p>
                            <p className="shardi_rasiid">
                                {Shardi2}
                            </p>
                            <p className="shardi_rasiid">
                               {Shardi3}
                            </p>
                        </div>
                        <div className="saxeexa_">
                            <img src="/images/HD_Signiture.png" alt="Saxiix" />
                            <h2>Hamse Ahmed Suleiman</h2>
                            <p>Gudoomiyaha Shabakada E-Sako.</p>
                            <p>Saxeex________________</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
        <div className="Head_jawaab">
            <div className=" back" onClick={ActiveSako}>
                <i className="fa-solid fa-circle-arrow-left"></i>
            </div>
            {/* <div className="sax">
                <img src="/images/check.svg" alt="ssc" />
            </div>                        */}
            <div className="close" onClick={ActiveJawaab}>
            
                <i className="fa-solid fa-circle-xmark"></i>
            </div>
        </div>
        <div className="jawaab_contenet">
            <h2>{muti}</h2>
            <p>{jawaab} 
            {Nooc == 'Lacag' ?
                 <span> Dollar </span>
                :Nooc == 'Geel'|| Nooc == 'Lo,a'|| Nooc == 'Adhi'?
                 <span> Neef</span>
                :Nooc == 'Dahab' || Nooc == 'Fido' || Nooc == 'Rikaas' ?
                <span> Giraam</span>
                :Nooc == 'Midho' ?
                <span> KG</span>
                : <></>
            }</p>
        </div>
        <div className="shuruud">
            <h2><i className="fa-solid fa-circle-check"></i> Shuruuda Sakadaad</h2>
            <p>{Shardi1}</p>
            <p>{Shardi2} </p>
            <p>{Shardi3}</p>
        </div>
        <button className="print_btn" onClick={handlePrint}><i className="fa-solid fa-print"></i> Daabaco Jawaabta (A5)</button>
        </div>
    )
}

export default Jawaab